/**
 * Couleurs prédéfinies pour les garanties
 */

export const DEFAULT_WARRANTY_COLOR = '#8074af';

export const PREDEFINED_COLORS = [
  { hex: '#8074af', label: 'Violet (défaut)' },
  { hex: '#667eea', label: 'Indigo' },
  { hex: '#3b82f6', label: 'Bleu' },
  { hex: '#10b981', label: 'Vert' },
  { hex: '#f59e0b', label: 'Orange' },
  { hex: '#ef4444', label: 'Rouge' },
  { hex: '#ec4899', label: 'Rose' },
  { hex: '#8b5cf6', label: 'Violet foncé' },
  { hex: '#06b6d4', label: 'Cyan' },
  { hex: '#64748b', label: 'Gris' },
] as const;
